import {MyExpression, xpathVisitor} from './xpathVisitor';
import {EnvironmentConfigService} from '../../core/services/environment-config.service';
import antlr4, {InputStream, CommonTokenStream} from '../../utils/interop/antlr4';
// @ts-ignore - Generated ANTLR files don't have TypeScript definitions
import xpathLexer from './xpathLexer.js';
// @ts-ignore - Generated ANTLR files don't have TypeScript definitions
import xpathParser from './xpathParser.js';

export class MyParser {
  static parse(xpath: string, envConfigService?: EnvironmentConfigService): MyExpression {
    const chars = new InputStream(xpath);
    const lexer = new xpathLexer(chars);
    const tokens = new CommonTokenStream(lexer);
    const parser = new xpathParser(tokens);
    parser.buildParseTrees = true;
    const ctx = parser.start();
    const exception = MyParser.getExceptions(ctx);
    if (exception !== false) {
      throw exception;
    }
    return new xpathVisitor(envConfigService).visitStart(ctx);
  }

  private static getExceptions(ctx): any {
    if (ctx.exception != null) {
      return ctx.exception;
    } else {
      if (!Array.isArray(ctx.children)) return false;
      for (let i = 0; i < ctx.children.length; i++) {
        const e = this.getExceptions(ctx.children[i]);
        if (e !== false) {
          return e;
        }
      }
    }
    return false;
  }
}
